import { FormValues, parseNilToEmptyString, pickOrCreate } from 'utils-next/forms'
import * as Yup from 'yup'

import { flow } from 'lodash'

import { ApiUserData, User } from '../../../../../../../../entities-next/user'

const keysFromUser = [
  'id',
  'firstName',
  'lastName',
  'email',
  'role',
  'admin',
  'askForOnboarding',
  'highlighted',
  'status',
  'position',
  'corporateId',
  'passwordResetToken',
]

export type UserFormData = FormValues<
  Pick<
    User,
    | 'id'
    | 'firstName'
    | 'lastName'
    | 'email'
    | 'role'
    | 'admin'
    | 'askForOnboarding'
    | 'highlighted'
    | 'status'
    | 'position'
    | 'corporateId'
    | 'passwordResetToken'
  >
>

export const userDataFormValidationSchema = Yup.object().shape({
  firstName: Yup.string().required(),
  lastName: Yup.string().required(),
  position: Yup.string(),
  email: Yup.string().email().required(),
  role: Yup.mixed().required(),
  status: Yup.mixed().required(),
})

export function parseUserToUserFormData({ ...userData }: User): UserFormData {
  const formCorporateData = flow(pickOrCreate(keysFromUser), parseNilToEmptyString)(userData)
  return formCorporateData
}

export async function parseUserFormDataToUser({ ...otherData }: UserFormData): Promise<ApiUserData> {
  return {
    ...otherData,
    position: otherData.position !== undefined ? otherData.position : '',
    admin: otherData.admin ? otherData.admin : false,
    askForOnboarding: otherData.askForOnboarding ? otherData.askForOnboarding : false,
    highlighted: otherData.highlighted ? otherData.highlighted : false,
    corporateId: otherData.corporateId,
  }
}
